import { render, staticRenderFns } from "./left.vue?vue&type=template&id=4ee24a2e&scoped=true&"
import script from "./left.vue?vue&type=script&lang=ts&"
export * from "./left.vue?vue&type=script&lang=ts&"
import style0 from "./left.vue?vue&type=style&index=0&id=4ee24a2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee24a2e",
  null
  
)

export default component.exports